<template>
  <form
    :class="{'nx-active': active}"
    data-vv-scope="liveMessages"
    id="scope-liveMessages"
    class="nx-form">
    <nx-live-messages-data-table
      v-validate
      data-vv-name="liveMessages"
      data-vv-scope="liveMessages"
    ></nx-live-messages-data-table>
  </form>
</template>

<script>
import FormScope from '@/modules/form/FormScope';
import DataTable from '@/modules/live-messages/components/DataTable';

export default {
  name: 'nx-live-messages-editor',
  extends: FormScope,
  components: {
    [DataTable.name]: DataTable,
  },
  props: {
    value: {
      type: [Array, Object],
      default: () => {
      },
    },
  },
};
</script>
<style></style>
